<template>
    <div class="input-ctr red-border" @mouseover="over()" @mouseleave="leave()">
            <transition name="fade">
               <span class="clear-btn" v-show="showClearIcon&&showClearBtn"  @click="clear" ><i class="icon-delete"></i></span>
            </transition>
            <input
                :id="elementId"
                :autocomplete="autocomplete"
                :spellcheck="spellcheck"
                ref="input"
                :type="type"
               	class="input"
                :placeholder="placeholder"
                :disabled="disabled"
                :maxlength="maxlength"
                :readonly="readonly"
                :name="name"
                :value="currentValue"
                :number="number"
                onkeyup="value=value.replace(/[<>]/g,'')"
                :autofocus="autofocus"
                @click.stop="clickInput"
                @keyup.enter="handleEnter"
                @keyup="handleKeyup"
                @keypress="handleKeypress"
                @keydown="handleKeydown"
                @focus="handleFocus"
                @blur="handleBlur"
                @input="handleInput"
                @change="handleChange">
          
      <span class="title" ref="title" v-if="title">{{title}}</span>
   <span class="suffix" v-if="suffix">
    {{suffix}}
  </span>
        <!--  <label for="text" v-show="showplaceholder" v-if="isIe==false">{{placeholder}}</label> -->
    </div>
</template>
<script>
import { oneOf, findComponentUpward } from "../../utils/assist";
import Emitter from "../../mixins/emitter";

export default {
  name: "uInput",
  mixins: [Emitter],
  props: {
     title: {
      type: String,
      default: ""
    },
    type: {
      validator(value) {
        return oneOf(value, ["text", "password","number","email"]);
      },
      default: "text"
    },
    showClearBtn: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxlength: {
      type: Number
    },
    suffix: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: String,
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    number: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    spellcheck: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      validator(value) {
        return oneOf(value, ["on", "off"]);
      },
      default: "off"
    },
    elementId: {
      type: String
    }
  },
  data() {
    return {
      currentValue: this.value,
      prepend: true,
      append: true,
      showClearIcon: false,
      showplaceholder: true,
      isIe: true
    };
  },

  methods: {
    clear() {
      this.currentValue = "";
      this.$emit("input", "");
      let _this=this;
      setTimeout(function(){
	        _this.dispatch("FormItem", "on-form-blur", _this.currentValue);
	        _this.dispatch("FormItem", "is-form-blur", true);
	    },200)
    },
    handleEnter(event) {
      this.$emit("on-enter", event);
    },
    handleKeydown(event) {
      this.$emit("on-keydown", event);
    },
    clickInput(){

    },
    handleKeypress(event) {
      this.$emit("on-keypress", event);
    },
    handleKeyup(event) {
      this.$emit("on-keyup", event);
    },
    handleIconClick(event) {
      this.$emit("on-click", event);
      
    },
    handleFocus(event) {
      this.$emit("on-focus", event);
      let _this=this;
	    setTimeout(function(){
	        _this.dispatch("FormItem", "is-choice", true);
	    },200)
    },
    handleBlur(event) {
      this.$emit("on-blur", event);
       let _this=this;
	    setTimeout(function(){
	        _this.dispatch("FormItem", "on-form-blur", _this.currentValue);
	        _this.dispatch("FormItem", "is-form-blur", true);
	    },200)
    },
    handleInput(event) {
      let value = event.target.value;
      if (this.number)
        value = Number.isNaN(Number(value)) ? value : Number(value);
      value=value.replace(/(^\s*)|(\s*$)/g, "");
      this.$emit("input", value);
      this.setCurrentValue(value);
      this.$emit("on-change", event);
    },
    handleChange(event) {
      this.$emit("on-input-change", event);
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;

      this.currentValue = value;
       this.dispatch("FormItem", "on-form-change", value);
    },

    focus() {
      this.$refs.input.focus();
    },
    blur() {
      this.$refs.input.blur();
    },
    over() {
      if (this.currentValue.length > 1) {
        this.showClearIcon = true;
      }
    },
    leave() {
      this.showClearIcon = false;
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    }
  },
  created() {
    var ie = navigator.appVersion.indexOf("MSIE") != -1; // 是否IE
    if (ie) {
      this.isIe = true;
    }
  },
  mounted() {
    if (this.$refs.title) {
      this.$refs.input.style.paddingLeft = `${this.$refs.title.innerText.strWidth() +
        1}em`;
    }
    // if (this.type !== "textarea") {
    //   this.prepend = this.$slots.prepend !== undefined;
    //   this.append = this.$slots.append !== undefined;
    // }
    this.slotReady = true;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/uInput/uInput.vue